<script>
	import { createEventDispatcher } from "svelte";
	import Spinner from "../../components/HTMLElements/Spinner.svelte";
	const dispatch = new createEventDispatcher();
	export let backUrl = "";
	export let disabled = false;
	export let buttonText = "";
    export let isPageLoading = true;
    export let showFooterButtons = true;
</script>

{#if isPageLoading}
	<Spinner />
{:else}
	
          
            
                <div class="column">
                    {#if backUrl != ""}
                <a
				tabindex="0"
				href="#"
				on:click|preventDefault={() => {			
					dispatch('pageChange', backUrl);
				}}>
				<span class="fas fa-arrow-left" />
				Back
            </a>
            {/if}
            <h1 class="title is-3" id="header" style="margin-top:0.75rem;">Feedback</h1>
            </div>
        <slot />
       {#if showFooterButtons }       
        <hr />
     
        <div class="columns" style="margin-right:0rem;margin-left:0px;">
        <div class="column">
      <button
            class="button is-primary"
            {disabled}
            on:click={() => dispatch('handleNext')}>
            {buttonText}
        </button>
    </div>
    </div>
        {/if}      
        {/if}